export default __webpack_public_path__ + "static/media/leaves.552f35d0.svg";